export default {
    "MCKPK": {
        "Text": "MCK Partial Knee",
        "Parameters": [
            {
                "MCKPK.FemoralComponent": {
                    "Text": "Femoral Component",
                    "Items": {
                        "MCKPK.FemoralComponent.MedialUni": {
                            "Text": "Medial Uni"
                        },
                        "MCKPK.FemoralComponent.LateralUni": {
                            "Text": "Lateral Uni"
                        },
                        "MCKPK.FemoralComponent.Bicomp": {
                            "Text": "Bicomp (Medial + PF)"
                        },
                        "MCKPK.FemoralComponent.IsolatedPF": {
                            "Text": "Isolated PF"
                        }
                    }
                }
            },
            {
                "MCKPK.InsertType": {
                    "Text": "Insert Type",
                    "Items": {
                        "MCKPK.InsertType.Onlay​": {
                            "Text": "Onlay​"
                        },
                        "MCKPK.InsertType.None": {
                            "Text": "None"
                        }
                    }
                }
            },
            {
                "MCKPK.Baseplate": {
                    "Text": "Baseplate",
                    "Items": {
                        "MCKPK.Baseplate.Onlay​": {
                            "Text": "Onlay"
                        },
                        "MCKPK.Baseplate.None​": {
                            "Text": "None​"
                        }
                    }
                }
            }
        ],
        "ImplantData": {
            "MCKPK.FemoralImplantSize": {
                "Text": "Femoral Implant Size"
            },
            "MCKPK.TibialImplantSize": {
                "Text": "Tibial Implant Size"
            }
        },
        "ValidCombinations": [
            [ "MCKPK.FemoralComponent.MedialUni", "MCKPK.InsertType.Onlay​", "MCKPK.Baseplate.Onlay​" ],
            [ "MCKPK.FemoralComponent.LateralUni", "MCKPK.InsertType.Onlay​", "MCKPK.Baseplate.Onlay​" ],
            [ "MCKPK.FemoralComponent.Bicomp", "MCKPK.InsertType.Onlay​", "MCKPK.Baseplate.Onlay​" ],
            [ "MCKPK.FemoralComponent.IsolatedPF", "MCKPK.InsertType.None", "MCKPK.Baseplate.None​" ]
        ]
    }
}